// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"43df4d5c","338":"661c17f8","741":"be0f3250"}[chunkId] + ".chunk.css";
};